

mp-top-logo {
  .mp-top-logo {
    margin-bottom: calc(var(--space-default) * 2);
  }

  hylo-router-link {
    &.hylo-has-focus {
      --hylo-router-link-outline: 2px solid var(--color-font-one);
    }
  }

  .fs-top {
    display: none;
  }

  .fachservice & {
    display: flex;

    .fs-top {
      display: flex;
      flex-grow: 1;
      justify-content: space-between;
      margin-bottom: calc(var(--space-default) * 2);
    }

    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--color-font-two);
      font-size: 1.5rem;
      font-weight: $bold;
      text-transform: uppercase;
      padding: 0 32px;

      .is-md & {
        font-size: 1.3rem;
      }
    }
    
    .social {
      display: flex;
      max-width: 300px;
      height: 100%;
      justify-content: flex-end;
      align-items: center;
      gap: 40px;
      padding: 0;
      flex-grow: 1;
      color: var(--color-font-two);

      .is-md & {
        gap: 30px;
      }

      .is-xs & {
        max-width: 200px;
        column-gap: 10px;
        padding: 0 10px;
      }

      hylo-router-link {
        justify-content: center;

        * {
          --icon-width: 40px !important;
        }

        .is-xs & {
          * {
            --icon-width: 35px !important;
          }
        }
      }
    }
  }

  .section-background-dark & {
   
    .fachservice & {

      .title {
        color: var(--color-font-three);
      }

      .social {
        color: var(--color-font-three);
      }
    }
  }
}
